import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, styled, TextField, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import { LoadingPage } from "../../../../common/LoadingPage";
import { apiRequest } from "../../../../common/common";

const DemoTypo = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    fontSize: 13
}));

const DemoTypography = styled(Typography)(({ theme }) => ({
    color: '#1565c0',
    fontSize: 13
}));

const ActionDate = ({
    itemData,
    getInitialData
}) => {
    const [isOpen, setOpen] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const [dates, setDates] = useState({
        purchased: null,
        shipped: null,
        received: null,
        in_storage: null,
        damaged: null,
        returned: null,
        accepted: null,
        installation_date: null,
        tested: null,
        activated: null,
        biomed_inspected: null,
        training: null,
        asset_tagged: null,
        in_use: null,
    });

    useEffect(() => {
        if (itemData && isOpen) {
            setDates({
                purchased: moment(itemData?.purchased).format('YYYY-MM-DD'),
                shipped: moment(itemData?.shipped).format('YYYY-MM-DD'),
                received: moment(itemData?.received).format('YYYY-MM-DD'),
                in_storage: moment(itemData?.in_storage).format('YYYY-MM-DD'),
                damaged: moment(itemData?.damaged).format('YYYY-MM-DD'),
                returned: moment(itemData?.accepted).format('YYYY-MM-DD'),
                accepted: moment(itemData?.accepted).format('YYYY-MM-DD'),
                installation_date: moment(itemData?.installation_date).format('YYYY-MM-DD'),
                tested: moment(itemData?.tested).format('YYYY-MM-DD'),
                activated: moment(itemData?.activated).format('YYYY-MM-DD'),
                biomed_inspected: moment(itemData?.biomed_inspected).format('YYYY-MM-DD'),
                training: moment(itemData?.training).format('YYYY-MM-DD'),
                asset_tagged: moment(itemData?.asset_tagged).format('YYYY-MM-DD'),
                in_use: moment(itemData?.in_use).format('YYYY-MM-DD'),
            });
        }
    }, [itemData, isOpen]);

    return (
        <>
            <Dialog open={isOpen} fullWidth maxWidth="sm">
                <DialogTitle>Action Dates</DialogTitle>
                <DialogContent>
                    {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
                    <Grid container spacing={2} mt={0.2}>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Purchased"
                                id="purchased-date"
                                type="date"
                                fullWidth
                                size="small"
                                value={dates?.purchased || ''}
                                onChange={(e) => {
                                    setDates((prevData) => ({
                                        ...prevData,
                                        purchased: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: dates?.purchased !== null && dates?.purchased !== '', // Shrink label when input is filled
                                }}
                                inputProps={{
                                    style: { padding: '10px' }, // Adjust padding and height if needed
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Shipped"
                                id="shipped-date"
                                type="date"
                                fullWidth
                                size="small"
                                value={dates?.shipped || ''}
                                onChange={(e) => {
                                    setDates((prevData) => ({
                                        ...prevData,
                                        shipped: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: dates?.shipped !== null && dates?.shipped !== '', // Shrink label when input is filled
                                }}
                                inputProps={{
                                    style: { padding: '10px' }, // Adjust padding and height if needed
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Received"
                                id="received-date"
                                type="date"
                                fullWidth
                                size="small"
                                value={dates?.received || ''}
                                onChange={(e) => {
                                    setDates((prevData) => ({
                                        ...prevData,
                                        received: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: dates?.received !== null && dates?.received !== '', // Shrink label when input is filled
                                }}
                                inputProps={{
                                    style: { padding: '10px' }, // Adjust padding and height if needed
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="In Storage"
                                id="in_storage-date"
                                type="date"
                                fullWidth
                                size="small"
                                value={dates?.in_storage || ''}
                                onChange={(e) => {
                                    setDates((prevData) => ({
                                        ...prevData,
                                        in_storage: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: dates?.in_storage !== null && dates?.in_storage !== '', // Shrink label when input is filled
                                }}
                                inputProps={{
                                    style: { padding: '10px' }, // Adjust padding and height if needed
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Damaged"
                                id="damaged-date"
                                type="date"
                                fullWidth
                                size="small"
                                value={dates?.damaged || ''}
                                onChange={(e) => {
                                    setDates((prevData) => ({
                                        ...prevData,
                                        damaged: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: dates?.damaged !== null && dates?.damaged !== '', // Shrink label when input is filled
                                }}
                                inputProps={{
                                    style: { padding: '10px' }, // Adjust padding and height if needed
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Returned"
                                id="returned-date"
                                type="date"
                                fullWidth
                                size="small"
                                value={dates?.returned || ''}
                                onChange={(e) => {
                                    setDates((prevData) => ({
                                        ...prevData,
                                        returned: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: dates?.returned !== null && dates?.returned !== '', // Shrink label when input is filled
                                }}
                                inputProps={{
                                    style: { padding: '10px' }, // Adjust padding and height if needed
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Accepted"
                                id="accepted-date"
                                type="date"
                                fullWidth
                                size="small"
                                value={dates?.accepted || ''}
                                onChange={(e) => {
                                    setDates((prevData) => ({
                                        ...prevData,
                                        accepted: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: dates?.accepted !== null && dates?.accepted !== '', // Shrink label when input is filled
                                }}
                                inputProps={{
                                    style: { padding: '10px' }, // Adjust padding and height if needed
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Installation"
                                id="installation-date"
                                type="date"
                                fullWidth
                                size="small"
                                value={dates?.installation_date || ''}
                                onChange={(e) => {
                                    setDates((prevData) => ({
                                        ...prevData,
                                        installation_date: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: dates?.installation_date !== null && dates?.installation_date !== '', // Shrink label when input is filled
                                }}
                                inputProps={{
                                    style: { padding: '10px' }, // Adjust padding and height if needed
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Tested"
                                id="tested-date"
                                type="date"
                                fullWidth
                                size="small"
                                value={dates?.tested || ''}
                                onChange={(e) => {
                                    setDates((prevData) => ({
                                        ...prevData,
                                        tested: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: dates?.tested !== null && dates?.tested !== '', // Shrink label when input is filled
                                }}
                                inputProps={{
                                    style: { padding: '10px' }, // Adjust padding and height if needed
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Activated"
                                id="activated-date"
                                type="date"
                                fullWidth
                                size="small"
                                value={dates?.activated || ''}
                                onChange={(e) => {
                                    setDates((prevData) => ({
                                        ...prevData,
                                        activated: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: dates?.activated !== null && dates?.activated !== '', // Shrink label when input is filled
                                }}
                                inputProps={{
                                    style: { padding: '10px' }, // Adjust padding and height if needed
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Biomed Inspected"
                                id="biomed_inspected-date"
                                type="date"
                                fullWidth
                                size="small"
                                value={dates?.biomed_inspected || ''}
                                onChange={(e) => {
                                    setDates((prevData) => ({
                                        ...prevData,
                                        biomed_inspected: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: dates?.biomed_inspected !== null && dates?.biomed_inspected !== '', // Shrink label when input is filled
                                }}
                                inputProps={{
                                    style: { padding: '10px' }, // Adjust padding and height if needed
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Training"
                                id="training-date"
                                type="date"
                                fullWidth
                                size="small"
                                value={dates?.training || ''}
                                onChange={(e) => {
                                    setDates((prevData) => ({
                                        ...prevData,
                                        training: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: dates?.training !== null && dates?.training !== '', // Shrink label when input is filled
                                }}
                                inputProps={{
                                    style: { padding: '10px' }, // Adjust padding and height if needed
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Asset Tagged"
                                id="asset_tagged-date"
                                type="date"
                                fullWidth
                                size="small"
                                value={dates?.asset_tagged || ''}
                                onChange={(e) => {
                                    setDates((prevData) => ({
                                        ...prevData,
                                        asset_tagged: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: dates?.asset_tagged !== null && dates?.asset_tagged !== '', // Shrink label when input is filled
                                }}
                                inputProps={{
                                    style: { padding: '10px' }, // Adjust padding and height if needed
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="In Use"
                                id="in_use-date"
                                type="date"
                                fullWidth
                                size="small"
                                value={dates?.in_use || ''}
                                onChange={(e) => {
                                    setDates((prevData) => ({
                                        ...prevData,
                                        in_use: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: dates?.in_use !== null && dates?.in_use !== '', // Shrink label when input is filled
                                }}
                                inputProps={{
                                    style: { padding: '10px' }, // Adjust padding and height if needed
                                }}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button size="small" variant="contained" color="secondary"
                        onClick={() => {
                            setOpen(false);
                            setDates({
                                purchased: null,
                                shipped: null,
                                received: null,
                                in_storage: null,
                                damaged: null,
                                returned: null,
                                accepted: null,
                                installation_date: null,
                                tested: null,
                                activated: null,
                                biomed_inspected: null,
                                training: null,
                                asset_tagged: null,
                                in_use: null,
                            });
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={async () => {
                            try {
                                setDataLoading(true);
                                const response = await apiRequest('put', `/project-item/${itemData?.item_id}`, {
                                    ...itemData,
                                    purchased: dates?.purchased !== 'Invalid date' ? moment(dates?.purchased).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    shipped: dates?.shipped !== 'Invalid date' ? moment(dates?.shipped).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    received: dates?.received !== 'Invalid date' ? moment(dates?.received).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    in_storage: dates?.in_storage !== 'Invalid date' ? moment(dates?.in_storage).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    damaged: dates?.damaged !== 'Invalid date' ? moment(dates?.damaged).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    returned: dates?.returned !== 'Invalid date' ? moment(dates?.returned).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    accepted: dates?.accepted !== 'Invalid date' ? moment(dates?.accepted).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    installation_date: dates?.installation_date !== 'Invalid date' ? moment(dates?.installation_date).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    tested: dates?.tested !== 'Invalid date' ? moment(dates?.tested).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    activated: dates?.activated !== 'Invalid date' ? moment(dates?.activated).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    biomed_inspected: dates?.biomed_inspected !== 'Invalid date' ? moment(dates?.biomed_inspected).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    training: dates?.training !== 'Invalid date' ? moment(dates?.training).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    asset_tagged: dates?.asset_tagged !== 'Invalid date' ? moment(dates?.asset_tagged).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    in_use: dates?.in_use !== 'Invalid date' ? moment(dates?.in_use).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                });
                                if (response.data) {
                                    setOpen(false);
                                    setDates({
                                        purchased: null,
                                        shipped: null,
                                        received: null,
                                        in_storage: null,
                                        damaged: null,
                                        returned: null,
                                        accepted: null,
                                        installation_date: null,
                                        tested: null,
                                        activated: null,
                                        biomed_inspected: null,
                                        training: null,
                                        asset_tagged: null,
                                        in_use: null,
                                    });
                                    getInitialData();
                                    setDataLoading(false);
                                    showNotification(response.data.message, 'success');
                                }
                            } catch (error) {
                                setDataLoading(false);
                                showNotification(error?.response?.data.error || error.message, 'error');
                            }
                        }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                <Typography varaint="body1" style={{ fontWeight: 'bold' }}>Action Date</Typography>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{
                        textTransform: 'capitalize'
                    }}
                    onClick={() => {
                        setOpen(true);
                    }}
                >
                    Add
                </Button>
            </Box>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Purchased:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.purchased ? moment(itemData?.purchased).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Received:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.received ? moment(itemData?.received).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Damaged:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.damaged ? moment(itemData?.damaged).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Accepted:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.accepted ? moment(itemData?.accepted).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Tested:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.tested ? moment(itemData?.tested).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Biomed Inspected:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.biomed_inspected ? moment(itemData?.biomed_inspected).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Asset Tagged:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.asset_tagged ? moment(itemData?.asset_tagged).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box display="flex" alignItems="center" gap={1} mt={1}>
                        <DemoTypography variant="body2">Shipped:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.shipped ? moment(itemData?.shipped).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">In Storage:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.in_storage ? moment(itemData?.in_storage).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Returned:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.returned ? moment(itemData?.returned).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Installation:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.installation_date ? moment(itemData?.installation_date).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Activated:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.activated ? moment(itemData?.activated).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Training:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.training ? moment(itemData?.training).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">In Use:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.in_use ? moment(itemData?.in_use).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

export default ActionDate;